import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import moment from 'moment'
import { notifyMessage } from '@/services/notify'
import { hoaUtility } from '@/services/Hoa/store'

var DEFAULT_FORM_VALUES = {
  communicationID: 0,
  audienceType: '',
  communication: null
}

export const methods = {
  async loadHoaTimezone() {
    await hoaUtility
      .dispatch('getHoaById', {
        hoaID: this.hoaId && this.hoaId > 0 ? this.hoaId : 0
      })
      .then(({ result }) => {
        if (result) {
          if (result.timezoneName) {
            this.myTimezone = result.timezoneName
          } else {
            this.myTimezone = 'Not Setup'
          }
        }
      })

    this.$store.dispatch('communication/saveTimezone', {
      timezone: this.myTimezone
    })
  },

  async pointInit() {
    this.point =
      this.deliveryDate && this.deliveryDate.length > 0
        ? new Date(this.deliveryDate).toISOString()
        : new Date().toISOString()
    this.pointFormatted = moment(this.point).format('LLL')
  },

  async reload() {
    this.loading = true

    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('communicationID=' + this.communicationID)

    this.formData = { ...DEFAULT_FORM_VALUES }

    await this.pointInit()

    try {
      await mailingCommunicationStore
        .dispatch('getCommunicationById', {
          communicationID: this.mailingCommunicationID || this.communicationID
        })
        .then(async ({ result }) => {
          if (result) {
            if (this.isDebug == true) console.debug('communication=' + JSON.stringify(result))

            this.communication = result

            await this.loadScheduleList()
          }
        })
    } catch (e) {
      console.debug('error while loading reload communication audience:' + e)
    }

    this.loading = false
  },

  async processInputSelection() {
    console.debug('in processInputSelection()' + this.formData.scheduleSelection)
    this.showFutureDates = true
    if (this.formData.scheduleSelection === 'Future Dates') {
      //await this.processFutureDate()
      let meetingRefDate =
        this.mailingType !== undefined &&
        this.mailingType !== 'Mail' &&
        this.$refs.futureDeliveryDate !== undefined
          ? this.$refs.futureDeliveryDate.getValue()
          : null

      this.meetingRefDateValue = meetingRefDate ? meetingRefDate.value : ''
    } else {
      this.showFutureDates = false
      await this.processImmediateDelivery(true)
    }
  },

  async processFutureDate(showMessage) {
    console.debug('processFutureDate()...')
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    const meetingRefDate = this.$refs.futureDeliveryDate.getValue()
    this.meetingRefDateValue = meetingRefDate.value

    console.debug('meetingRefDate=' + meetingRefDate.value)

    this.$store.dispatch('communication/saveDeliveryDate', {
      deliveryDate: meetingRefDate.value
    })

    const params = {
      communicationID: this.mailingCommunicationID,
      supportMailDelivery: this.mailingType === 'Mail',
      supportEmailDelivery: this.mailingType === 'Email',
      supportSMSDelivery: this.mailingType === 'SMS',
      supportPushDelivery: this.supportPushDelivery,
      isLegalCommunication: this.isLegalCommunication,
      description: this.communicationDescription,
      mailFullDuplex: this.isDuplexParam,
      mailColor: this.isColorParam,
      deliveryDate: meetingRefDate.value
    }

    await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
      params,
      done: async ({ detail }) => {
        this.$store.dispatch('communication/saveIsEdit', {
          isEdit: true
        })

        if (detail) {
          this.communicationID = detail.communicationID

          if (showMessage !== undefined && showMessage && showMessage === true) {
            notifyMessage('This message is set to be delivered at a future date.')
          }
        }
      }
    })

    loadingComponent.close()
  },

  processDateSelection() {
    console.debug('in processDateSelection...')
    this.processFutureDate(true)
  },

  processDateOnlySelection() {
    console.debug('in processDateOnlySelection...')
    this.processFutureDateOnly(true)
  },

  async processImmediateDelivery(showMessage) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    this.$store.dispatch('communication/saveDeliveryDate', {
      deliveryDate: null
    })

    const params = {
      communicationID: this.mailingCommunicationID,
      supportMailDelivery: this.mailingType === 'Mail',
      supportEmailDelivery: this.mailingType === 'Email',
      supportSMSDelivery: this.mailingType === 'SMS',
      supportPushDelivery: this.supportPushDelivery,
      isLegalCommunication: this.isLegalCommunication,
      description: this.communicationDescription,
      mailFullDuplex: this.isDuplexParam,
      mailColor: this.isColorParam,
      deliveryDate: moment('01/01/1900')
    }

    await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
      params,
      done: async ({ detail }) => {
        if (detail) {
          this.$store.dispatch('communication/saveIsEdit', {
            isEdit: true
          })

          this.communicationID = detail.communicationID

          if (showMessage !== undefined && showMessage && showMessage === true) {
            notifyMessage('This message is set to be delivered immediately.')
          }
        }
      }
    })

    loadingComponent.close()
  },

  async processSchedule(showMessage) {
    if (this.formData.scheduleSelection === 'Future Dates') {
      await this.processFutureDate(showMessage)
    } else {
      await this.processImmediateDelivery(showMessage)
    }
  },

  async redirectToFutureDate() {
    this.point =
      this.deliveryDate && this.deliveryDate.length > 0
        ? new Date(this.deliveryDate).toISOString()
        : new Date().toISOString()
    this.pointFormatted = moment(this.point).format('LLL')
  },

  async loadScheduleList() {
    console.debug('loadScheduleList...')
    try {
      this.scheduleList = [
        { value: '', label: '<- Select a Schedule ->' },
        { value: 'Immediately', label: 'Immediately' },
        { value: 'Future Dates', label: 'Future Dates' }
      ]

      this.formData.scheduleSelection = ''

      console.debug('in loadScheduleList...' + JSON.stringify(this.communication))

      if (this.communication !== undefined && this.communication) {
        if (this.communication.deliveryDate !== undefined && this.communication.deliveryDate) {
          this.formData.scheduleSelection = 'Future Dates'
          this.showFutureDates = true
        } else if (this.communicationID !== undefined && this.communicationID > 0) {
          this.formData.scheduleSelection = 'Immediately'
          this.showFutureDates = false
        }
      }

      console.debug('scheduleList=' + JSON.stringify(this.scheduleList))
    } catch (e) {
      console.debug(e)
    }
  }
}
